import injector from 'vue-inject'
import Vue from 'vue'
import * as types from './mutation-types'
import * as helpers from './helpers'

export default {
  [types.CLEAN_STATE] (state) {
    Vue.set(state, 'channels', {
      main: {
        getFilterConfig: injector.get('filterConfigs').getKitchenFilterConfig,
        orderList: []
      },
      secondary: {
        getFilterConfig: injector.get('filterConfigs').getPreOrderFilterConfig,
        orderList: []
      }
    })
  },
  [types.SET_ORDER_LIST] (state, { orderList, channel = 'main', params: { limit = 100, offset = 0 } }) {
    if (orderList) {
      if (offset === 0) {
        const conditions = state.channels[channel].getFilterConfig({ limit, offset }).conditions
        const keywords = state.channels[channel].getFilterConfig({ limit, offset }).keywords
        if (conditions) {
          Vue.set(state.channels[channel], 'orderList', orderList.filter(order =>
            helpers.satisfyFilterCondition(order, conditions))
          )
        } else if (keywords) {
          Vue.set(state.channels[channel], 'orderList', orderList)
        }
      } else {
        orderList.forEach(order =>
          helpers.insertOrder(state.channels[channel].orderList, order, state.channels[channel].getFilterConfig(), false)
        )
      }
    }
  },
  [types.UPDATE_ORDER_FROM_UI] (state, { order, ring }) {
    Object.keys(state.channels).forEach(k => {
      helpers.insertOrder(state.channels[k].orderList, order, state.channels[k].getFilterConfig(), ring)
    })
  },
  [types.SET_FILTER_CONFIG] (state, { getFilterConfig, channel = 'main' }) {
    Vue.set(state.channels[channel], 'getFilterConfig', getFilterConfig)
  },
  [types.UPDATE_ORDER_FROM_SERVER] (state, { order, ring }) {
    Object.keys(state.channels).forEach(k => {
      helpers.insertOrder(state.channels[k].orderList, order, state.channels[k].getFilterConfig(), ring)
    })
  },
  [types.SET_NEW_ORDER] (state, order) {
    if (helpers.isValidNewOrder(order)) {
      Vue.set(state, 'newOrder', order)
    }
  },
  [types.SET_ERROR_MESSAGE] (state, message) {
    state.orderErrorMessage = message
  }
}
